var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5 21.5H16.8333V13.625C16.8333 12.39 15.4475 11.3568 14.2124 11.3568C12.9774 11.3568 12.1667 12.39 12.1667 13.625V21.5H7.50001V7.5H12.1667V9.83333C12.9394 8.58333 14.9158 7.77681 16.2792 7.77681C19.1626 7.77681 21.5 10.1584 21.5 13.0417V21.5ZM5.16667 21.5H0.5V7.5H5.16667V21.5ZM2.83334 0.5C4.12201 0.5 5.16668 1.54467 5.16668 2.83333C5.16668 4.122 4.12201 5.16667 2.83334 5.16667C1.54468 5.16667 0.500012 4.122 0.500012 2.83333C0.500012 1.54467 1.54468 0.5 2.83334 0.5Z"}));
}

Linkedin.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
